// Fixed yearly occasions. Each array is a flat list of [day, month, title]
// triples in its own calendar system, decoded by services/occasions.ts:
//   - a negative day marks an official public holiday
//   - in the hijri list the day may be 'lstday' / '-lstday' — the month's last
//     day (29th or 30th, resolved against the observed month length at match
//     time, so moon-sighting adjustments move it correctly)
//
// The hijri list carries every religious occasion, anchored to its hijri day
// rather than a solar date, so all of them follow the moon-sighting
// adjustments (see configs/hijri-adjustments.ts). Solar-anniversary occasions
// belong in the jalaali list even when they commemorate a religious figure.

export const J_OCCASIONS: (number | string)[] = [
    -1, 1, 'عید نوروز، جشن سال نو',
    -2, 1, 'جشن نوروز',
    -3, 1, 'جشن نوروز',
    -4, 1, 'جشن نوروز',
    6, 1, 'زادروز زرتشت پیامبر',
    6, 1, 'روز امید، روز شادباش نویسی',
    7, 1, 'روز هنرهای نمایشی',
    -12, 1, 'روز جمهوری اسلامی ایران',
    -13, 1, 'روز طبیعت، جشن سیزده به در',
    17, 1, 'روز فرهنگ پهلوانی و ورزش زورخانه‌ای',
    18, 1, 'روز سلامتی',
    23, 1, 'روز دندانپزشک',
    25, 1, 'روز بزرگداشت عطار نیشابوری',
    29, 1, 'روز ارتش',
    30, 1, 'روز علوم آزمایشگاهی، زادروز حکیم سید اسماعیل جرجانی',
    1, 2, 'روز بزرگداشت سعدی، روز نثر فارسی',
    3, 2, 'روز بزرگداشت شیخ بهایی، روز ملی کارآفرینی، روز معماری',
    8, 2, 'روز ایمنی حمل و نقل',
    9, 2, 'روز شوراها',
    9, 2, 'روز ملی روانشناس و مشاور',
    10, 2, 'روز ملی خلیج فارس',
    12, 2, 'روز معلم',
    18, 2, 'روز بیماری‌های خاص و صعب‌العلاج',
    22, 2, 'زادروز مریم میرزاخانی، روز جهانی زن در ریاضیات',
    25, 2, 'روز پاسداشت زبان فارسی و بزرگداشت فردوسی',
    27, 2, 'روز ارتباطات و روابط عمومی',
    28, 2, 'روز بزرگداشت حکیم عمر خیام',
    30, 2, 'روز ملی جمعیت',
    31, 2, 'روز اهدای عضو، اهدای زندگی',
    1, 3, 'روز بهره‌وری و بهینه‌سازی مصرف',
    3, 3, 'سالروز آزادسازی خرمشهر (۱۳۶۱)',
    -14, 3, 'سالروز درگذشت روح الله خمینی',
    -15, 3, 'سالروز وقایع ۱۵ خرداد',
    21, 3, 'روز خانواده و تکریم بازنشستگان',
    25, 3, 'روز ملی گل و گیاه',
    25, 3, 'روز جهاد کشاورزی، تشکیل جهاد سازندگی (۱۳۵۸)',
    1, 4, 'روز اصناف',
    5, 4, 'روز تجلیل از اسرا و مفقودان',
    8, 4, 'روز مبارزه با سلاح‌های شیمیایی و میکروبی',
    10, 4, 'روز صنعت و معدن',
    10, 4, 'روز دیپلماسی فرهنگی و تعامل با جهان',
    14, 4, 'روز قلم',
    15, 4, 'جشن خام‌خواری',
    18, 4, 'روز ادبیات کودکان و نوجوانان',
    22, 4, 'زادروز محمد خوارزمی، روز فناوری اطلاعات',
    25, 4, 'روز بهزیستی و تأمین اجتماعی',
    27, 4, 'پذیرش قطعنامه ۵۹۸ شورای امنیت از سوی ایران (۱۳۶۷)',
    6, 5, 'روز ترویج آموزش‌های فنی و حرفه‌ای',
    9, 5, 'روز اهدای خون',
    28, 5, 'سالروز وقایع ۲۸ مرداد',
    1, 6, 'روز بزرگداشت ابوعلی سینا، روز پزشک',
    2, 6, 'آغاز هفته دولت',
    4, 6, 'زادروز نمادین کوروش کبیر',
    4, 6, 'روز کارمند',
    5, 6, 'روز بزرگداشت محمد بن زکریای رازی، روز داروسازی، روز کشتی',
    7, 6, 'روز وقف',
    11, 6, 'روز صنعت چاپ',
    13, 6, 'روز تعاون، روز بزرگداشت ابوریحان بیرونی، روز علوم پایه',
    19, 6, 'درگذشت آیت‌الله طالقانی (۱۳۵۸)',
    21, 6, 'روز سینما',
    27, 6, 'روز شعر و ادب فارسی، روز بزرگداشت شهریار',
    30, 6, 'روز گفتگوی تمدن‌ها',
    31, 6, 'آغاز جنگ ایران و عراق',
    2, 7, 'روز پرچم',
    4, 7, 'روز سرباز',
    5, 7, 'روز گردشگری',
    7, 7, 'روز آتش‌نشانی و ایمنی، روز بزرگداشت شمس',
    8, 7, 'روز بزرگداشت مولوی',
    10, 7, 'مهر روز، جشن مهرگان',
    10, 7, 'روز نخبگان',
    14, 7, 'روز دامپزشکی',
    15, 7, 'روز روستا و عشایر',
    16, 7, 'روز ملی کودک',
    20, 7, 'روز بزرگداشت حافظ',
    26, 7, 'روز تربیت بدنی و ورزش',
    29, 7, 'روز ملی کوهنورد',
    29, 7, 'روز صادرات',
    1, 8, 'روز بزرگداشت ابوالفضل بیهقی',
    1, 8, 'روز آمار و برنامه‌ریزی',
    7, 8, 'روز بزرگداشت کوروش کبیر',
    14, 8, 'روز فرهنگ عمومی',
    18, 8, 'روز ملی کیفیت',
    21, 8, 'روز هوافضا',
    24, 8, 'روز کتاب، کتاب‌خوانی و کتابدار',
    30, 8, 'روز قهرمان ملی',
    30, 8, 'روز بزرگداشت ابونصر فارابی، روز حکمت و فلسفه',
    1, 9, 'آذرجشن',
    7, 9, 'روز نیروی دریایی',
    7, 9, 'روز نوآوری و فناوری ایران‌ساخت',
    13, 9, 'روز بیمه',
    15, 9, 'روز حسابدار',
    25, 9, 'روز پژوهش',
    26, 9, 'روز حمل و نقل',
    30, 9, 'شب یلدا، ترویج فرهنگ میهمانی و پیوند با خویشان',
    5, 10, 'روز ایمنی در برابر زلزله و کاهش اثرات بلایای طبیعی',
    5, 11, 'جشن نوسره',
    6, 11, 'روز بزرگداشت صفی‌الدین ارموی، روز آواها و نواهای ایرانی',
    10, 11, 'جشن سده',
    14, 11, 'روز فناوری فضایی',
    19, 11, 'روز نیروی هوایی',
    -22, 11, 'پیروزی انقلاب اسلامی',
    29, 11, 'جشن سپندارمذگان، روز عشق',
    30, 11, 'روز کارآفرینی',
    5, 12, 'روز بزرگداشت زمین و بانوان',
    5, 12, 'روز بزرگداشت خواجه نصیرالدین طوسی، روز مهندسی',
    7, 12, 'سالروز استقلال کانون وکلای دادگستری، روز وکیل مدافع',
    7, 12, 'سالروز درگذشت علی‌اکبر دهخدا',
    14, 12, 'روز احسان و نیکوکاری، روز ترویج فرهنگ قرض‌الحسنه',
    15, 12, 'روز درختکاری، روز آموزش همگانی حفظ محیط زیست',
    17, 12, 'روز بزرگداشت سید جمال‌الدین اسدآبادی',
    21, 12, 'روز بزرگداشت نظامی گنجوی',
    25, 12, 'روز بزرگداشت پروین اعتصامی، روز تکریم همسایگان',
    -29, 12, 'روز ملی شدن صنعت نفت ایران (۱۳۲۹)',
]

export const G_OCCASIONS: (number | string)[] = [
    27, 3, 'روز جهانی تئاتر',
    30, 3, 'روز جهانی پسماند صفر',
    2, 4, 'روز جهانی کتاب کودک',
    2, 4, 'روز جهانی آگاهی از اوتیسم',
    4, 4, 'روز جهانی آگاهی از مین و کمک به مین‌زدایی',
    5, 4, 'روز جهانی وجدان',
    6, 4, 'روز جهانی ورزش برای توسعه و صلح',
    7, 4, 'روز جهانی بهداشت',
    12, 4, 'روز جهانی پرواز انسان به فضا',
    15, 4, 'روز جهانی تندرستی',
    16, 4, 'روز جهانی کتابداران ویژه',
    20, 4, 'روز جهانی زبان چینی',
    21, 4, 'روز جهانی خلاقیت و نوآوری',
    22, 4, 'جشن گیاه آوری؛ روز زمین',
    23, 4, 'روز جهانی کتاب',
    23, 4, 'روز جهانی دختران در فناوری اطلاعات و ارتباطات',
    23, 4, 'روز جهانی زبان انگلیسی',
    23, 4, 'روز جهانی زبان اسپانیایی',
    24, 4, 'آغاز هفته جهانی ایمن‌سازی',
    24, 4, 'روز جهانی چندجانبه‌گرایی و دیپلماسی برای صلح',
    25, 4, 'روز جهانی مالاریا',
    25, 4, 'روز جهانی نمایندگان',
    26, 4, 'روز جهانی یادبود فاجعه چرنوبیل',
    26, 4, 'روز جهانی مالکیت فکری',
    27, 4, 'روز جهانی طراحی و گرافیک',
    28, 4, 'روز جهانی ایمنی و بهداشت کار',
    29, 4, 'روز جهانی یادبود قربانیان زلزله',
    30, 4, 'روز جهانی جاز',
    1, 5, 'روز جهانی کار و کارگر',
    1, 5, 'ویساک، روز ماه کامل',
    2, 5, 'روز جهانی ماهی تن',
    3, 5, 'روز جهانی آزادی مطبوعات',
    5, 5, 'روز جهانی ماما',
    5, 5, 'روز جهانی زبان پرتغالی',
    8, 5, 'روز جهانی صلیب سرخ و هلال احمر',
    8, 5, 'روز یادبود و آشتی برای جان‌باختگان جنگ جهانی دوم',
    9, 5, 'روز جهانی پرندگان مهاجر',
    12, 5, 'روز جهانی پرستار',
    12, 5, 'روز جهانی سلامت گیاه',
    13, 5, 'روز جهانی مهندسی IEEE',
    15, 5, 'روز جهانی خانواده',
    16, 5, 'روز جهانی زیستن با یکدیگر در صلح',
    16, 5, 'روز جهانی نور',
    17, 5, 'روز جهانی فشار خون',
    17, 5, 'روز جهانی ارتباطات و جامعه اطلاعاتی',
    18, 5, 'روز جهانی موزه و میراث فرهنگی',
    19, 5, 'روز جهانی بازی جوانمردانه',
    20, 5, 'روز جهانی زنبور عسل',
    21, 5, 'روز جهانی تنوع فرهنگی',
    21, 5, 'روز جهانی چای',
    22, 5, 'روز جهانی تنوع زیستی',
    23, 5, 'روز جهانی پایان دادن به فیستول زایمانی',
    24, 5, 'روز جهانی اسکیزوفرنی',
    25, 5, 'روز جهانی فوتبال',
    29, 5, 'روز جهانی حافظان صلح سازمان ملل',
    30, 5, 'روز جهانی سیب‌زمینی',
    31, 5, 'روز جهانی بدون دخانیات',
    1, 6, 'روز جهانی شیر',
    1, 6, 'روز جهانی والدین',
    3, 6, 'روز جهانی دوچرخه',
    5, 6, 'روز جهانی محیط زیست',
    5, 6, 'روز جهانی مبارزه با صید غیرقانونی و گزارش‌نشده',
    6, 6, 'روز جهانی زبان روسی',
    7, 6, 'روز جهانی ایمنی غذا',
    8, 6, 'روز جهانی اقیانوس',
    10, 6, 'روز جهانی صنایع دستی',
    10, 6, 'روز جهانی گفتگوی تمدن‌ها',
    11, 6, 'روز جهانی بازی',
    12, 6, 'روز جهانی مبارزه با کار کودکان',
    14, 6, 'روز جهانی اهدای خون',
    15, 6, 'روز جهانی آگاهی از آزار سالمندان',
    16, 6, 'روز جهانی کودک آفریقایی',
    17, 6, 'روز جهانی بیابان زدایی',
    20, 6, 'روز جهانی پناهندگان',
    21, 6, 'روز جهانی یوگا',
    24, 6, 'روز جهانی زنان در دیپلماسی',
    25, 6, 'روز جهانی دریانوردان',
    26, 6, 'روز جهانی مبارزه با مواد مخدر',
    26, 6, 'روز جهانی حمایت از قربانیان شکنجه',
    6, 7, 'روز جهانی توسعه روستایی',
    11, 7, 'روز جهانی جمعیت',
    11, 7, 'روز جهانی اسب',
    12, 7, 'روز جهانی مقابله با طوفان‌های شن و گرد و غبار',
    12, 7, 'روز جهانی امید',
    15, 7, 'روز جهانی مهارت‌آموزی جوانان',
    18, 7, 'روز جهانی نلسون ماندلا',
    20, 7, 'روز جهانی شطرنج',
    20, 7, 'روز جهانی ماه',
    25, 7, 'روز جهانی پیشگیری از غرق شدن',
    28, 7, 'روز جهانی هپاتیت',
    30, 7, 'روز جهانی دوستی',
    30, 7, 'روز جهانی مبارزه با قاچاق انسان',
    1, 8, 'آغاز هفته جهانی شیردهی',
    6, 8, 'روز جهانی آگاهی از چالش‌های توسعه کشورهای محصور در خشکی',
    7, 8, 'روز جهانی دوستی',
    8, 8, 'روز جهانی و بین المللی بی نهایت',
    9, 8, 'روز جهانی مردم بومی جهان',
    10, 8, 'روز جهانی بیودیزل',
    11, 8, 'روز جهانی استیل‌پن',
    12, 8, 'روز جهانی جوانان',
    13, 8, 'روز جهانی چپ دست ها',
    19, 8, 'روز جهانی عکاسی',
    19, 8, 'روز جهانی بشردوستی',
    21, 8, 'روز جهانی یادبود قربانیان تروریسم',
    22, 8, 'روز جهانی یادبود قربانیان خشونت بر پایه دین یا باور',
    23, 8, 'روز جهانی یادآوری تجارت برده و لغو آن',
    27, 8, 'روز جهانی دریاچه‌ها',
    29, 8, 'روز جهانی مبارزه با آزمایش‌های هسته‌ای',
    5, 9, 'روز جهانی نیکوکاری',
    7, 9, 'روز جهانی هوای پاک برای آسمان آبی',
    7, 9, 'روز جهانی همکاری پلیس',
    8, 9, 'روز جهانی سوادآموزی',
    9, 9, 'روز جهانی حفاظت از آموزش در برابر حمله',
    10, 9, 'روز جهانی پیشگیری از خودکشی',
    11, 9, 'حمله به برج‌های دوقلوی مرکز تجارت جهانی',
    13, 9, 'روز گرامیداشت برنامه نویسان',
    15, 9, 'روز آزادی نرم افزار',
    15, 9, 'روز جهانی دموکراسی',
    16, 9, 'روز جهانی حفاظت از لایه اوزون',
    18, 9, 'روز جهانی برابری دستمزد',
    20, 9, 'روز جهانی پاکسازی زمین',
    21, 9, 'روز جهانی صلح',
    22, 9, 'روز جهانی بدون خودرو',
    23, 9, 'روز جهانی زبان‌های اشاره',
    24, 9, 'روز جهانی دریانوردی',
    26, 9, 'روز جهانی حذف کامل سلاح‌های هسته‌ای',
    27, 9, 'روز جهانی جهانگردی',
    28, 9, 'روز جهانی دسترسی همگانی به اطلاعات',
    29, 9, 'روز مخترعان',
    29, 9, 'روز جهانی قلب',
    29, 9, 'روز جهانی آگاهی از هدررفت و ضایعات غذا',
    30, 9, 'روز جهانی ناشنوایان',
    30, 9, 'روز جهانی ترجمه و مترجم',
    1, 10, 'روز جهانی سالمندان',
    1, 10, 'روز جهانی موسیقی',
    1, 10, 'روز جهانی باله',
    1, 10, 'روز جهانی قهوه',
    2, 10, 'روز جهانی حیوانات مزرعه',
    2, 10, 'روز جهانی عدم خشونت',
    3, 10, 'روز جهانی اعتدال',
    4, 10, 'روز جهانی حیوانات',
    4, 10, 'آغاز هفته جهانی فضا',
    5, 10, 'روز جهانی معلم',
    6, 10, 'روز جهانی اسکان بشر',
    7, 10, 'روز جهانی پنبه',
    9, 10, 'روز جهانی پست',
    9, 10, 'روز جهانی پرندگان مهاجر',
    10, 10, 'روز جهانی مبارزه با حکم اعدام',
    10, 10, 'روز جهانی بهداشت روان',
    11, 10, 'روز جهانی دختر',
    13, 10, 'روز جهانی کاهش خطر بلایای طبیعی',
    14, 10, 'روز جهانی استاندارد',
    15, 10, 'روز جهانی عصای سفید',
    15, 10, 'روز جهانی زنان روستایی',
    16, 10, 'روز جهانی غذا',
    17, 10, 'روز جهانی ریشه کنی فقر',
    24, 10, 'روز سازمان ملل متحد',
    24, 10, 'آغاز هفته خلع سلاح',
    24, 10, 'روز جهانی اطلاع‌رسانی توسعه',
    24, 10, 'آغاز هفته جهانی سواد رسانه‌ای و اطلاعاتی',
    27, 10, 'روز جهانی میراث دیداری و شنیداری',
    29, 10, 'روز جهانی اینترنت',
    29, 10, 'روز جهانی مراقبت و حمایت',
    31, 10, 'روز جهانی شهرها',
    5, 11, 'روز جهانی آگاهی از سونامی',
    6, 11, 'روز جهانی پیشگیری از تخریب محیط زیست در جنگ',
    8, 11, 'روز جهانی شهرسازی',
    9, 11, 'آغاز هفته جهانی علم و صلح',
    10, 11, 'روز جهانی علم در خدمت صلح و توسعه',
    14, 11, 'روز جهانی دیابت',
    15, 11, 'روز جهانی مبارزه با جرایم سازمان‌یافته فراملی',
    16, 11, 'روز جهانی مدارا',
    16, 11, 'روز جهانی رژیم غذایی مدیترانه‌ای',
    17, 11, 'روز جهانی یادبود قربانیان تصادفات جاده‌ای',
    18, 11, 'روز جهانی فلسفه',
    18, 11, 'آغاز هفته جهانی آگاهی از مقاومت ضدمیکروبی',
    18, 11, 'روز جهانی پیشگیری از بهره‌کشی جنسی و خشونت علیه کودکان',
    19, 11, 'روز جهانی آقایان',
    19, 11, 'روز جهانی توالت',
    20, 11, 'روز جهانی کودک',
    21, 11, 'روز جهانی تلویزیون',
    25, 11, 'روز جهانی مبارزه با خشونت علیه زنان',
    26, 11, 'روز جهانی حمل و نقل پایدار',
    30, 11, 'روز جهانی امنیت کامپیوتر',
    30, 11, 'روز یادبود قربانیان جنگ شیمیایی',
    1, 12, 'روز جهانی ایدز',
    2, 12, 'روز جهانی لغو برده داری',
    3, 12, 'روز جهانی معلولان',
    4, 12, 'روز جهانی بانک‌ها',
    4, 12, 'روز جهانی مبارزه با اقدامات قهری یکجانبه',
    5, 12, 'روز جهانی داوطلبان',
    5, 12, 'روز جهانی خاک',
    7, 12, 'روز جهانی هوانوردی غیرنظامی',
    9, 12, 'روز جهانی یادبود و کرامت قربانیان نسل‌کشی',
    9, 12, 'روز جهانی مبارزه با فساد',
    10, 12, 'روز حقوق بشر',
    11, 12, 'روز جهانی کوه نوردی',
    12, 12, 'روز جهانی بی‌طرفی',
    12, 12, 'روز جهانی پوشش همگانی سلامت',
    14, 12, 'روز جهانی مبارزه با استعمار در همه اشکال آن',
    15, 12, 'روز جهانی خانواده زبان‌های ترکی',
    18, 12, 'روز جهانی مهاجران',
    18, 12, 'روز جهانی زبان عربی',
    20, 12, 'روز جهانی همبستگی انسانی',
    21, 12, 'روز جهانی مدیتیشن',
    21, 12, 'روز جهانی بسکتبال',
    24, 12, 'روز جهانی مبارزه با جرایم سایبری',
    25, 12, 'جشن کریسمس',
    25, 12, 'روز بزرگداشت دوستی',
    27, 12, 'روز جهانی آمادگی در برابر همه‌گیری',
    1, 1, 'جشن آغاز سال نو میلادی',
    4, 1, 'روز جهانی خط بریل',
    11, 1, 'روز جهانی تشکر',
    24, 1, 'روز جهانی آموزش',
    26, 1, 'روز جهانی انرژی پاک',
    27, 1, 'روز جهانی یادبود قربانیان هولوکاست',
    28, 1, 'روز جهانی همزیستی مسالمت‌آمیز',
    30, 1, 'روز جهانی جذام',
    1, 2, 'آغاز هفته جهانی همزیستی ادیان',
    2, 2, 'روز جهانی تالاب‌ها',
    4, 2, 'روز جهانی برادری انسانی',
    6, 2, 'روز جهانی عدم تحمل ختنه دختران',
    10, 2, 'روز جهانی حبوبات',
    10, 2, 'روز جهانی پلنگ عربی',
    11, 2, 'روز جهانی زنان و دختران در علم',
    12, 2, 'روز جهانی پیشگیری از افراط‌گرایی خشونت‌آمیز',
    13, 2, 'روز جهانی رادیو',
    14, 2, 'جشن ولنتاین',
    17, 2, 'روز جهانی تاب‌آوری گردشگری',
    20, 2, 'روز جهانی عدالت اجتماعی',
    21, 2, 'روز جهانی زبان مادری',
    22, 2, 'روز جهانی تفکر',
    1, 3, 'روز جهانی عدم تبعیض',
    1, 3, 'روز جهانی علف‌های دریایی',
    3, 3, 'روز جهانی حیات وحش',
    5, 3, 'روز جهانی آگاهی از خلع سلاح و منع اشاعه سلاح',
    8, 3, 'روز جهانی زنان',
    10, 3, 'روز جهانی زنان قاضی',
    14, 3, 'روز جهانی عدد پی π',
    20, 3, 'روز جهانی شادی',
    20, 3, 'روز جهانی زبان فرانسه',
    21, 3, 'روز جهانی سندروم داون',
    21, 3, 'روز جهانی نوروز',
    21, 3, 'روز جهانی جنگل',
    21, 3, 'روز جهانی شعر',
    21, 3, 'روز جهانی یخچال‌های طبیعی',
    21, 3, 'روز جهانی رفع تبعیض نژادی',
    22, 3, 'روز جهانی آب',
    23, 3, 'روز جهانی هواشناسی',
    24, 3, 'روز جهانی سل',
    24, 3, 'روز جهانی حق دانستن حقیقت درباره نقض حقوق بشر',
    25, 3, 'ساعت زمین',
    25, 3, 'روز جهانی یادبود قربانیان برده‌داری و تجارت برده',
    25, 3, 'روز جهانی همبستگی با کارکنان بازداشت‌شده و ناپدیدشده',
]

export const H_OCCASIONS: (number | string)[] = [
    -9, 1, 'تاسوعا',
    -10, 1, 'عاشورا',
    -20, 2, 'اربعین',
    -28, 2, 'وفات پیامبر',
    '-lstday', 2, 'شهادت امام رضا',
    -8, 3, 'شهادت امام حسن عسکری',
    12, 3, 'ولادت پیامبر به روایت اهل سنت',
    -17, 3, 'ولادت پیامبر',
    13, 5, 'وفات فاطمه زهرا (به روایتی)',
    -3, 6, 'وفات فاطمه زهرا',
    -13, 7, 'ولادت امام علی و روز پدر',
    -27, 7, 'عید مبعث',
    -15, 8, 'نیمه شعبان',
    -21, 9, 'شهادت امام علی',
    -1, 10, 'عید فطر',
    -2, 10, 'تعطیل به مناسبت عید فطر',
    -25, 10, 'شهادت امام صادق',
    9, 12, 'روز عرفه، روز نیایش',
    -10, 12, 'عید قربان',
    -18, 12, 'عید غدیر خم',
]
